import styled from "styled-components";

const StyledSvg = styled.svg`
  height: 1em;
  padding-right: 0.2em;
  padding-left: 0.2em;
`;

interface ConnectedIconProps {
  isConnected: boolean;
}

const ConnectedIcon = ({ isConnected }: ConnectedIconProps) => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <g
      transform="matrix(1.37217 0 0 1.37217-27.479-15.472)"
      fillOpacity={isConnected ? "1" : "0.502"}
      fill={isConnected ? "green" : "#4e4e4e"}
    >
      <path d="m28.04 13.847c-2.891 0-5.608 1.126-7.652 3.17l1.167 1.167c1.732-1.732 4.04-2.686 6.485-2.686 2.45 0 4.753.954 6.485 2.686l1.167-1.167c-2.044-2.044-4.761-3.17-7.652-3.17" />
      <path d="m22.466 19.09l1.167 1.167c1.178-1.178 2.745-1.828 4.412-1.828 1.667 0 3.233.649 4.412 1.828l1.167-1.167c-1.49-1.49-3.471-2.311-5.579-2.311-2.108 0-4.089.821-5.579 2.311" />
      <path d="m24.541 21.17l1.167 1.167c.624-.624 1.454-.968 2.337-.968.883 0 1.712.344 2.337.968l1.167-1.167c-.936-.936-2.18-1.451-3.504-1.451-1.324 0-2.568.515-3.504 1.451" />
      <path d="m28.04 22.994c-.429 0-.858.164-1.185.491-.011.011-.022.023-.033.035l1.218 1.222 1.221-1.218c-.012-.013-.024-.026-.036-.038-.327-.327-.756-.491-1.185-.491" />
      {!isConnected && (
        <line
          stroke={"var(--color-field-point-0)"}
          x1="15"
          y1="0"
          x2="45"
          y2="45"
        ></line>
      )}
    </g>
  </StyledSvg>
);

export default ConnectedIcon;
